module.exports = __webpack_public_path__ + "static/media/map-marker.30286afb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map-marker.svg
// module id = 633
// module chunks = 0